import { render } from "./RegionAlmatyObl.vue?vue&type=template&id=490b0c92&ts=true"
import script from "./RegionAlmatyObl.vue?vue&type=script&lang=ts"
export * from "./RegionAlmatyObl.vue?vue&type=script&lang=ts"

import "./RegionAlmatyObl.vue?vue&type=style&index=0&id=490b0c92&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__